(function () {
  if (window.__sjHomeInit) return;
  window.__sjHomeInit = true;
  const root = document.querySelector('.sj-home');
  if (!root) return;

  const toast = document.querySelector('.sj-toast');
  const toastText = toast ? toast.querySelector('.sj-toast-text') : null;
  let toastTimer = null;

  function showToast(msg) {
    if (!toast || !toastText) return;
    toastText.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('show'), 2400);
  }

  // Sport filter for product grid
  const filterBar = root.querySelector('.filter-bar');
  if (filterBar) {
    filterBar.addEventListener('click', (e) => {
      const btn = e.target.closest('.filter-btn');
      if (!btn) return;
      filterBar.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const filter = btn.dataset.filter;
      root.querySelectorAll('.product').forEach(card => {
        const tags = (card.dataset.tags || '').toLowerCase();
        let show = true;
        if (filter === 'football')   show = tags.includes('football');
        else if (filter === 'wrestling') show = !tags.includes('football');
        else if (filter !== 'all')   show = tags.includes(filter);
        card.hidden = !show;
      });
    });
  }

  // Add to cart — uses Shopify's AJAX cart API and notifies Dawn's cart drawer
  async function addToCart(variantId, qty, name) {
    const sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];
    try {
      const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: qty || 1 }],
          sections: sectionsToRender,
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (!res.ok) {
        showToast(data.description || 'Could not add');
        return;
      }
      showToast(`Added: ${name || 'item'}`);

      // Update Dawn's cart-icon-bubble + open the cart drawer
      const cartDrawerEl = document.querySelector('cart-drawer');
      if (cartDrawerEl && data.sections) {
        cartDrawerEl.renderContents(data);
      } else {
        // Fallback: hard refresh of cart icon count
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (err) {
      console.error('[sj-home] add to cart failed', err);
      showToast('Could not add — try again');
    }
  }

  // Modal: open / close
  function openModal(id) {
    const overlay = document.getElementById(id);
    if (!overlay) return;
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('open'));
    document.body.style.overflow = 'hidden';
    const focusTarget = overlay.querySelector('input[type="email"]') || overlay.querySelector('[data-close-modal]');
    if (focusTarget) setTimeout(() => focusTarget.focus(), 100);
  }
  function closeModal(overlay) {
    if (!overlay) return;
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    setTimeout(() => { overlay.hidden = true; }, 240);
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-modal]');
    if (opener) {
      e.preventDefault();
      openModal(opener.dataset.openModal);
      return;
    }
    const closer = e.target.closest('[data-close-modal]');
    if (closer) {
      closeModal(closer.closest('.sj-modal-overlay'));
      return;
    }
    if (e.target.classList && e.target.classList.contains('sj-modal-overlay')) {
      closeModal(e.target);
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = document.querySelector('.sj-modal-overlay.open');
    if (open) closeModal(open);
  });
  // Auto-open modal in success state, then auto-close after 3s
  const successFlag = document.querySelector('.sj-modal-overlay [data-success]');
  if (successFlag) {
    const overlay = successFlag.closest('.sj-modal-overlay');
    openModal(overlay.id);
    setTimeout(() => closeModal(overlay), 3000);
  }

  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest('.sj-home [data-add-variant]');
    if (!addBtn) return;
    e.preventDefault();
    const variantId = addBtn.dataset.addVariant;
    if (!variantId) return;
    const qty = Number(addBtn.dataset.qty || 1);
    const name = addBtn.dataset.addName || '';
    addBtn.disabled = true;
    addToCart(variantId, qty, name).finally(() => {
      addBtn.disabled = false;
    });
  });

  // Klaviyo SMS opt-in for the drop modal.
  // Flow: if phone is filled, POST to Klaviyo's client subscriptions API, then submit the
  // Shopify form so the customer record (with phone) is created/updated by Shopify too.
  function toE164US(raw) {
    if (!raw) return null;
    const trimmed = String(raw).trim();
    if (!trimmed) return null;
    const digits = trimmed.replace(/\D/g, '');
    if (trimmed.startsWith('+') && digits.length >= 8 && digits.length <= 15) return '+' + digits;
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.startsWith('1')) return '+' + digits;
    return null;
  }

  async function subscribeKlaviyo({ publicKey, listId, source, email, phone }) {
    const url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(publicKey);
    const profileAttrs = { subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } };
    if (email) profileAttrs.email = email;
    if (phone) profileAttrs.phone_number = phone;
    const body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source || 'Sticky Jams — Access Drop',
          profile: { data: { type: 'profile', attributes: profileAttrs } },
        },
      },
    };
    if (listId) {
      body.data.relationships = { list: { data: { type: 'list', id: listId } } };
    }
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2026-04-15' },
      body: JSON.stringify(body),
    });
    if (!res.ok && res.status !== 202) {
      let detail = '';
      try { detail = await res.text(); } catch (_) {}
      throw new Error('Klaviyo subscribe failed: ' + res.status + ' ' + detail);
    }
  }

  function showSmsError(form, msg) {
    const el = form.querySelector('[data-sms-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }
  function clearSmsError(form) {
    const el = form.querySelector('[data-sms-error]');
    if (!el) return;
    el.textContent = '';
    el.hidden = true;
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.sj-modal-form');
    if (!form || form.__sjKlaviyoSubmitting) return;

    const overlay = form.closest('.sj-modal-overlay');
    if (!overlay) return;

    const publicKey = overlay.dataset.klaviyoPublicKey;
    const listId = overlay.dataset.klaviyoListId;
    const source = overlay.dataset.klaviyoSource;

    const phoneInput = form.querySelector('[data-sj-phone]');
    const phoneRaw = phoneInput ? phoneInput.value : '';
    if (!phoneRaw || !phoneRaw.trim()) {
      clearSmsError(form);
      return; // no phone — let Shopify submit normally
    }

    const phone = toE164US(phoneRaw);
    if (!phone) {
      e.preventDefault();
      showSmsError(form, 'Please enter a valid US phone number (10 digits), or leave it blank.');
      phoneInput.focus();
      return;
    }
    phoneInput.value = phone;

    if (!publicKey) {
      clearSmsError(form);
      return; // Klaviyo not configured — Shopify still gets phone on customer record
    }

    e.preventDefault();
    clearSmsError(form);

    const submitBtn = form.querySelector('.sj-modal-submit');
    if (submitBtn) submitBtn.disabled = true;

    const emailInput = form.querySelector('input[name="contact[email]"]');
    const email = emailInput ? emailInput.value.trim() : '';

    try {
      await subscribeKlaviyo({ publicKey, listId, source, email, phone });
    } catch (err) {
      console.warn('[sj-home] Klaviyo subscribe failed', err);
      // Continue submitting to Shopify so the customer record + email opt-in still happen.
    }

    form.__sjKlaviyoSubmitting = true;
    form.submit();
  });
})();

/* sj-home.js is included by more than one section, so it can run twice on a page.
   Guard the interactive handlers below so their listeners attach only once. */
if (!window.__sjHomeUIInit) {
window.__sjHomeUIInit = true;

/* Custom Flow-style mobile nav: hamburger opens a full-screen overlay menu */
(function(){
  var openBtn = document.querySelector('[data-sj-nav-open]');
  var panel = document.querySelector('[data-sj-nav-panel]');
  if (!openBtn || !panel) return;
  function setOpen(open){
    panel.hidden = !open;
    openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  openBtn.addEventListener('click', function(){ setOpen(true); });
  panel.addEventListener('click', function(e){
    if (e.target === panel || e.target.closest('[data-sj-nav-close]') || e.target.closest('a')) setOpen(false);
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !panel.hidden) setOpen(false); });
})();

/* Sticky countdown bar: tick every second, hide at zero, offset the page by the bar height */
(function(){
  var el = document.getElementById('sj-countdown');
  if (!el) return;
  var home = el.closest('.sj-home');
  var endStr = (el.getAttribute('data-end') || '').trim().replace(' ', 'T');
  var end = endStr ? new Date(endStr) : null;
  var dEl = el.querySelector('[data-d]');
  var hEl = el.querySelector('[data-h]');
  var mEl = el.querySelector('[data-m]');
  var sEl = el.querySelector('[data-s]');
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function offset(){ if (home) home.style.paddingTop = el.offsetHeight + 'px'; }
  function hide(){ el.style.display = 'none'; if (home){ home.style.paddingTop = '0'; home.classList.remove('has-countdown'); } }
  if (!end || isNaN(end.getTime())) { hide(); return; }
  var iv;
  function tick(){
    var diff = Math.floor((end.getTime() - Date.now()) / 1000);
    if (diff <= 0) { hide(); clearInterval(iv); return; }
    var d = Math.floor(diff / 86400);
    var h = Math.floor((diff % 86400) / 3600);
    var m = Math.floor((diff % 3600) / 60);
    var s = diff % 60;
    if (dEl) { if (d > 0) { dEl.textContent = d + 'd '; dEl.style.display = 'inline'; } else { dEl.style.display = 'none'; } }
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
  }
  offset();
  window.addEventListener('resize', offset);
  tick();
  iv = setInterval(tick, 1000);
})();

/* "See how it works" — smooth-scroll to the section below the hero */
(function(){
  var btn = document.querySelector('[data-sj-scroll]');
  if (!btn) return;
  btn.addEventListener('click', function(e){
    e.preventDefault();
    var home = document.querySelector('.sj-home');
    var section = home ? home.closest('.shopify-section') : null;
    var target = section ? section.nextElementSibling : null;
    if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    else window.scrollBy({ top: Math.round(window.innerHeight * 0.9), behavior: 'smooth' });
  });
})();

/* How It Works — accordion (one card open at a time) */
(function(){
  var accs = document.querySelectorAll('[data-hiw-accordion]');
  if (!accs.length) return;
  accs.forEach(function(acc){
    acc.addEventListener('click', function(e){
      var header = e.target.closest('[data-hiw-toggle]');
      if (!header) return;
      var card = header.closest('.hiw-card');
      var willOpen = !card.classList.contains('is-open');
      acc.querySelectorAll('.hiw-card').forEach(function(c){
        c.classList.remove('is-open');
        var h = c.querySelector('[data-hiw-toggle]');
        if (h) h.setAttribute('aria-expanded', 'false');
      });
      if (willOpen) { card.classList.add('is-open'); header.setAttribute('aria-expanded', 'true'); }
    });
  });
})();

/* Review wall — show N cards, "see more" reveals more, optional shuffle */
(function(){
  var walls = document.querySelectorAll('[data-rw]');
  if (!walls.length) return;
  walls.forEach(function(root){
    var grid = root.querySelector('[data-rw-grid]');
    var btn = root.querySelector('[data-rw-btn]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-rw-card]'));
    if (!cards.length) return;
    var initial = parseInt(root.getAttribute('data-initial'), 10) || 4;
    var step = parseInt(root.getAttribute('data-step'), 10) || 4;
    var visible = initial;

    if (root.getAttribute('data-shuffle') === 'true' && grid && cards.length > 1) {
      for (var i = cards.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = cards[i]; cards[i] = cards[j]; cards[j] = tmp;
      }
      cards.forEach(function(c){ grid.appendChild(c); });
    }

    function render(n, animate){
      visible = Math.min(Math.max(n, initial), cards.length);
      cards.forEach(function(c, idx){
        var show = idx < visible;
        var was = c.classList.contains('is-visible');
        c.classList.toggle('is-visible', show);
        if (animate && show && !was) {
          c.classList.add('is-entering');
          setTimeout(function(){ c.classList.remove('is-entering'); }, 220);
        }
      });
      if (btn) btn.hidden = visible >= cards.length;
    }

    render(initial, false);
    if (btn) btn.addEventListener('click', function(){ render(visible + step, true); });
  });
})();

/* FAQ — "show more" reveals the rest of a group's questions */
(function(){
  var btns = document.querySelectorAll('[data-faq-more]');
  if (!btns.length) return;
  btns.forEach(function(btn){
    btn.addEventListener('click', function(){
      var group = btn.closest('[data-faq-group]');
      if (!group) return;
      var expanded = group.classList.toggle('is-expanded');
      var more = btn.getAttribute('data-more-label') || 'Show more';
      var less = btn.getAttribute('data-less-label') || 'Show less';
      btn.textContent = expanded ? less : more;
    });
  });
})();

/* FAQ — accordion (one card open at a time) */
(function(){
  var accs = document.querySelectorAll('[data-faq-accordion]');
  if (!accs.length) return;
  accs.forEach(function(acc){
    acc.addEventListener('click', function(e){
      var header = e.target.closest('[data-faq-toggle]');
      if (!header) return;
      var card = header.closest('.faq-card');
      var willOpen = !card.classList.contains('is-open');
      acc.querySelectorAll('.faq-card').forEach(function(c){
        c.classList.remove('is-open');
        var h = c.querySelector('[data-faq-toggle]');
        if (h) h.setAttribute('aria-expanded', 'false');
      });
      if (willOpen) { card.classList.add('is-open'); header.setAttribute('aria-expanded', 'true'); }
    });
  });
})();

/* How It Works — play the video when the poster button is clicked */
(function(){
  document.querySelectorAll('[data-hiw-video]').forEach(function(wrap){
    var btn = wrap.querySelector('[data-hiw-play]');
    var poster = wrap.querySelector('.hiw-video-poster');
    var video = wrap.querySelector('.hiw-video-el');
    if (!btn) return;
    btn.addEventListener('click', function(){
      if (!video) return;
      if (poster) poster.style.display = 'none';
      video.hidden = false;
      if (video.play) { var p = video.play(); if (p && p.catch) p.catch(function(){}); }
    });
  });
})();

/* Testimonials carousel — tap to play (with sound), tap again to pause; one at a time */
(function(){
  var track = document.querySelector('[data-tsm-track]');
  if (!track) return;
  var videos = track.querySelectorAll('.tsm-card-video');
  track.addEventListener('click', function(e){
    var card = e.target.closest('[data-tsm-card]');
    if (!card) return;
    var video = card.querySelector('.tsm-card-video');
    if (!video) return;
    var onPlayBtn = !!e.target.closest('[data-tsm-play]');
    if (onPlayBtn || !card.classList.contains('is-playing')) {
      videos.forEach(function(v){ if (v !== video) v.pause(); });
      track.querySelectorAll('[data-tsm-card].is-playing').forEach(function(c){ if (c !== card) c.classList.remove('is-playing'); });
      card.classList.add('is-playing');
      video.muted = false;
      var p = video.play();
      if (p && p.catch) p.catch(function(){ video.muted = true; video.play(); });
    } else {
      video.pause();
      card.classList.remove('is-playing');
    }
  });
})();

} /* end __sjHomeUIInit guard */
